import { ChangeDetectorRef, Component, OnInit, ViewChild } from '@angular/core';
import { ContestService } from 'src/app/services/contest/contest.service';
import { GalleryService } from 'src/app/services/gallery/gallery.service';
import { EventsService } from '../../services/event/event.service';
import { GamesService } from 'src/app/services/lobby/games.service';
import { IonContent } from '@ionic/angular';
import { DisplayMode, OrientationService } from 'src/app/services/orientation/orientation.service';

@Component({
  selector: 'app-gallery-casino',
  templateUrl: './gallery-casino.component.html'
})
export class GalleryCasinoComponent implements OnInit {

  @ViewChild(IonContent, { static: false }) content: IonContent;
  public gamelist: any[] = [];
  public contest: any;
  protected displayMode: DisplayMode; 

  constructor(
    private readonly contestService: ContestService,
    private readonly galleryService: GalleryService,
    private readonly gamesService: GamesService,
    private cgd:ChangeDetectorRef,
    private events: EventsService,
    private orientationService:OrientationService
  ) { }

  sortGames (allgames) {
    const favorites = allgames["Favorites"];
    const sortedFavorites = allgames.filter((game) => {
      if (!favorites) return false;
      let matched = false;
      for (let i = 0; i < favorites.length; i++) {
        if (game.id === favorites[i].id) matched = true;
      }
      return matched;
    }).sort((a, b) => {
      return favorites.findIndex((fav) => fav.id === a.id) - favorites.findIndex((fav) => fav.id === b.id);
    });
    const gamesWitoutFavorites = allgames.filter((game) => {
      if (!sortedFavorites) return true;
      let matched = false;
      for (let i = 0; i < sortedFavorites.length; i++) {
        if (game.id === sortedFavorites[i].id) {
          matched = true;
        }
      }
      return !matched;
    });

    this.gamelist = sortedFavorites?.concat(gamesWitoutFavorites) || allgames;
    this.cgd.detectChanges();
  }

  ngOnInit() {
    this.gamesService.getGames().subscribe((allgames) => {
      this.sortGames(allgames);
    });
    this.galleryService.getGameList().then((allgames) => {
      this.sortGames(allgames);
    });

    this.checkContest();
    this.events.subscribe("event:load-contest", () => {
      this.checkContest();
    });
    this.checkOrientation();
  }

  protected checkOrientation(){
    this.orientationService.displayMode$.subscribe((mode) => {
      this.displayMode = mode;
    });
    this.orientationService.handleOrientationChange();
  }

  protected checkContest() {
    this.contestService.getValidContest().then((response) => {
      this.contest = response[0];
    });
  }

  protected goToContestPage(): any {
    return this.contestService.openContest(this.contest);
  }

  ngOnDestroy() {
    console.log("Destroying all events froms galary casino")
    this.events.destroy("event:load-contest")
  }

}
